import { ActionIcon, Tooltip } from "@mantine/core";
import { IconPencil } from "@tabler/icons-react";

/**
 * Floating pencil button shown in the top-right corner of a layout block when
 * the block is selected. Click opens the block's edit modal. The button is
 * positioned absolutely; the surrounding NodeViewWrapper needs `position:
 * relative` (the helper class below sets it). Hidden until parent is selected
 * to keep the editor visually quiet.
 */
export function EditTrigger({
  onClick,
  label = "Edit",
}: {
  onClick: () => void;
  label?: string;
}) {
  return (
    <div
      contentEditable={false}
      style={{
        position: "absolute",
        top: 6,
        right: 6,
        zIndex: 2,
        pointerEvents: "auto",
      }}
      data-edit-trigger
    >
      <Tooltip label={label} withArrow>
        <ActionIcon
          size="sm"
          variant="default"
          onClick={onClick}
          aria-label={label}
        >
          <IconPencil size={14} />
        </ActionIcon>
      </Tooltip>
    </div>
  );
}

// Class to apply on the NodeViewWrapper — controls absolute positioning of
// the edit trigger and its hover/selected visibility (see CSS module).
export { default as layoutClasses } from "./layout-blocks.module.css";
